// import React, { useEffect, useState } from "react";
// import { jwtDecode } from "jwt-decode";
// import { URL } from "../../../config";
// import { FaGift, FaLock, FaCheck } from "react-icons/fa";
// import "./userRewards.css";
// import { useTranslation } from "react-i18next";

// const TIERS = [
//   { key: "bronze", threshold: 100, color: "#cd7f32" },
//   { key: "silver", threshold: 200, color: "#c0c0c0" },
//   { key: "gold", threshold: 300, color: "#ffd700" },
//   { key: "premium", threshold: 500, color: "#43b581" },
//   { key: "diamond", threshold: 1000, color: "#4fd1c5" },
//   { key: "elite", threshold: 1500, color: "#7c3aed" },
//   { key: "legend", threshold: 2000, color: "#ef4444" },
// ];

// export default function UserRewards() {
//   const { t } = useTranslation();
//   const [summary, setSummary] = useState({
//     rewardPoints: 0,
//     lifetimeRewardPoints: 0,
//     latestCoupon: null,
//     threshold: 100,
//     canClaim: false,
//   });
//   const [claiming, setClaiming] = useState(false);
//   const [claimedInfo, setClaimedInfo] = useState(null); // 🆕 show recent claim info

//   const points = Number(summary.rewardPoints || 0);
//   const claimThreshold = Number(summary.threshold || 100);
//   const progressPct = Math.min(100, Math.round((points / claimThreshold) * 100));
//   const canClaimNow = points >= claimThreshold;

//   // figure out current tier
//   const currentTier =
//     [...TIERS].reverse().find((tier) => points >= tier.threshold) || TIERS[0];

//   useEffect(() => {
//     const token = localStorage.getItem("token");
//     if (!token) return;
//     const decoded = jwtDecode(token);
//     const rawId = decoded.Id?.startsWith("user-")
//       ? decoded.Id.split("user-")[1]
//       : decoded.Id;

//     fetch(`${URL}/users/${rawId}/summary`)
//       .then((r) => r.json())
//       .then((data) => {
//         setSummary({
//           rewardPoints: data.rewardPoints ?? 0,
//           lifetimeRewardPoints: data.lifetimeRewardPoints ?? 0,
//           latestCoupon: data.latestCoupon ?? null,
//           canClaim: !!data.canClaim,
//           threshold: data.threshold ?? 100,
//         });
//       })
//       .catch(console.error);
//   }, []);

//   const handleClaim = async () => {
//     if (!canClaimNow || claiming) return;
//     try {
//       setClaiming(true);
//       const token = localStorage.getItem("token");
//       const { Id } = jwtDecode(token);
//       const rawId = Id?.startsWith("user-") ? Id.split("user-")[1] : Id;

//       const res = await fetch(`${URL}/users/${rawId}/claim`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//       });
//       const data = await res.json();
//       if (!res.ok) throw new Error(data?.message || "Claim failed");

//       // ✅ show coupon info and reset points
//       setClaimedInfo({
//         code: data.code,
//         tier: data.tier,
//         expiryDate: new Date(data.expiryDate).toLocaleDateString(),
//       });

//       const nextPoints = (summary.rewardPoints || 0) - claimThreshold;
//       setSummary((s) => ({
//         ...s,
//         rewardPoints: Math.max(0, nextPoints),
//         latestCoupon: data.code,
//         canClaim: nextPoints >= claimThreshold,
//       }));

//       alert(
//         `🎉 ${t("rewards.claimSuccess", {
//           amount: claimThreshold,
//         })}\nCoupon: ${data.code}\nTier: ${data.tier}\nValid till: ${new Date(
//           data.expiryDate
//         ).toLocaleDateString()}`
//       );
//     } catch (e) {
//       alert(e.message);
//     } finally {
//       setClaiming(false);
//     }
//   };

//   return (
//     <div className="rewards-wrapper">
//       {/* Compact banner at top */}
//       <div className="rw-banner">
//         <div className="rw-left">
//           <div className="rw-icon">
//             <FaGift />
//           </div>
//           <div className="rw-lines">
//             <div className="rw-title">{t("rewards.title")}</div>
//             <div className="rw-sub">{t("rewards.subtitle", { points })}</div>
//           </div>
//         </div>

//         <div className="rw-right">
//           <div className="rw-chip">
//             {points}/{claimThreshold} {t("rewards.unit")}
//           </div>
//           <div className="rw-bar">
//             <div className="rw-fill" style={{ width: `${progressPct}%` }} />
//           </div>
//           <button
//             className={`rw-cta ${!canClaimNow || claiming ? "locked" : ""}`}
//             onClick={handleClaim}
//             disabled={!canClaimNow || claiming}
//             title={
//               canClaimNow
//                 ? t("rewards.claimNow")
//                 : t("rewards.requirementShort", { threshold: claimThreshold })
//             }
//           >
//             {!canClaimNow ? <FaLock /> : <FaCheck />}{" "}
//             {claiming ? t("rewards.claiming") : t("rewards.claimNow")}
//           </button>
//         </div>
//       </div>

//       {/* Tier ladder */}
//       <div className="rw-card">
//         <div className="rw-card-title">{t("rewards.levelsTitle")}</div>
//         <div className="rw-tiers">
//           {TIERS.map((tier) => {
//             const achieved = points >= tier.threshold;
//             const active = currentTier.key === tier.key;
//             return (
//               <div
//                 key={tier.key}
//                 className={`rw-tier ${
//                   achieved ? "achieved" : ""
//                 } ${active ? "active" : ""}`}
//               >
//                 <div className="rw-tier-header">
//                   <span
//                     className="rw-tier-dot"
//                     style={{ background: tier.color }}
//                   />
//                   <span className="rw-tier-name">
//                     {t(`rewards.tiers.${tier.key}.name`)}
//                   </span>
//                   <span className="rw-tier-threshold">({tier.threshold}+)</span>
//                 </div>
//                 <div className="rw-tier-desc">
//                   {t(`rewards.tiers.${tier.key}.desc`)}
//                 </div>
//               </div>
//             );
//           })}
//         </div>
//       </div>

//       {/* Lifetime + Coupon Info */}
//       <div className="rw-stats-row">
//         <div className="rw-stat">
//           <div className="rw-stat-label">{t("rewards.lifetime")}</div>
//           <div className="rw-stat-value">
//             {summary.lifetimeRewardPoints || 0} {t("rewards.unit")}
//           </div>
//         </div>

//         {summary.latestCoupon && (
//           <div className="rw-stat">
//             <div className="rw-stat-label">{t("rewards.latestCoupon")}</div>
//             <div className="rw-stat-value">{summary.latestCoupon}</div>
//           </div>
//         )}
//       </div>

//       {/* Optional: show new claimed info */}
//       {claimedInfo && (
//         <div className="rw-claimed-popup">
//           <h4>🎁 New Coupon Generated!</h4>
//           <p>
//             <strong>Code:</strong> {claimedInfo.code}
//           </p>
//           <p>
//             <strong>Tier:</strong> {claimedInfo.tier}
//           </p>
//           <p>
//             <strong>Valid until:</strong> {claimedInfo.expiryDate}
//           </p>
//         </div>
//       )}
//     </div>
//   );
// }








// import React, { useEffect, useState } from "react";
// import { jwtDecode } from "jwt-decode";
// import { URL } from "../../../config";
// import { FaGift } from "react-icons/fa";
// import "./userRewards.css";
// import { useTranslation } from "react-i18next";

// const TIERS = [
//   { key: "bronze", threshold: 100, color: "#CD7F32", name: "Bronze", desc: "Starter level. Unlock basic perks." },
//   { key: "silver", threshold: 200, color: "#C0C0C0", name: "Silver", desc: "Better perks and small bonuses." },
//   { key: "gold", threshold: 300, color: "#FFD700", name: "Gold", desc: "Priority support and larger bonuses." },
//   { key: "premium", threshold: 500, color: "#9333EA", name: "Premium", desc: "Premium perks with special offers." },
//   { key: "diamond", threshold: 1000, color: "#40E0D0", name: "Diamond", desc: "Top-tier perks and exclusive deals." },
//   { key: "elite", threshold: 1500, color: "#8B00FF", name: "Elite", desc: "Elite status with elevated rewards." },
//   { key: "legend", threshold: 2000, color: "#FF0000", name: "Legend", desc: "Ultimate tier. Max benefits." },
// ];

// export default function UserRewards() {
//   const { t } = useTranslation();
//   const [summary, setSummary] = useState({
//     rewardPoints: 240,
//     lifetimeRewardPoints: 240,
//     latestCoupon: "HP023119R31",
//     expiryDate: new Date(Date.now() + 30 * 86400000).toISOString(),
//   });
//   const [claimingTier, setClaimingTier] = useState(null);
//   const [showModal, setShowModal] = useState(false);
//   const [pendingTier, setPendingTier] = useState(null);

//   const points = Number(summary.rewardPoints || 0);
//   const expiryDays = summary.expiryDate
//     ? Math.max(
//         0,
//         Math.ceil((new Date(summary.expiryDate) - new Date()) / (1000 * 60 * 60 * 24))
//       )
//     : null;

//   const currentTier =
//     [...TIERS].reverse().find((tier) => points >= tier.threshold) || TIERS[0];
//   const nextTier =
//     TIERS.find((tier) => tier.threshold > points) || TIERS[TIERS.length - 1];
//   const progressPct = Math.min(100, Math.round((points / nextTier.threshold) * 100));
//   const pointsToNext = Math.max(0, nextTier.threshold - points);

//   const confirmClaim = (tierKey) => {
//     if (summary.latestCoupon) {
//       setPendingTier(tierKey);
//       setShowModal(true);
//     } else {
//       handleClaimTier(tierKey);
//     }
//   };

//   const handleClaimTier = async (tierKey) => {
//     if (claimingTier) return;
//     try {
//       setClaimingTier(tierKey);
//       setShowModal(false);
//       const token = localStorage.getItem("token");
//       if (!token) return;
//       const { Id } = jwtDecode(token);
//       const rawId = Id?.startsWith("user-") ? Id.split("user-")[1] : Id;

//       const res = await fetch(`${URL}/users/${rawId}/claim`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ tierKey }),
//       });
//       const data = await res.json();
//       if (!res.ok) throw new Error(data?.message || "Claim failed");

//       setSummary((prev) => ({
//         ...prev,
//         rewardPoints: data.remainingPoints,
//         latestCoupon: data.code,
//         expiryDate: data.expiryDate,
//       }));

//       alert(`🎉 ${data.tier} Coupon Claimed!\nCode: ${data.code}`);
//     } catch (e) {
//       alert(e.message);
//     } finally {
//       setClaimingTier(null);
//     }
//   };

//   return (
//     <div className="userRewards-wrapper">
//       {/* Banner */}
//       <div className="userRewards-banner">
//         <div className="userRewards-banner-left">
//           <div className="userRewards-icon">
//             <FaGift />
//           </div>
//           <div className="userRewards-banner-text">
//             <h2>Rewards</h2>
//             <p>
//               {points} pts — {pointsToNext} pts to next level
//             </p>
//           </div>
//         </div>
//         <div className="userRewards-banner-right">
//           <div className="userRewards-progress">
//             <div
//               className="userRewards-progress-fill"
//               style={{ width: `${progressPct}%` }}
//             ></div>
//           </div>
//           <div className="userRewards-tier-chip">{currentTier.name}</div>
//         </div>
//       </div>

//       {/* Levels */}
//       <div className="userRewards-card">
//         <h3>Levels</h3>
//         <div className="userRewards-tiers">
//           {TIERS.map((tier) => {
//             const unlocked = points >= tier.threshold;
//             const claiming = claimingTier === tier.key;
//             return (
//               <div
//                 key={tier.key}
//                 className={`userRewards-tier ${unlocked ? "active" : ""}`}
//                 style={{ borderColor: unlocked ? tier.color : "#e5e7eb" }}
//               >
//                 <div
//                   className="userRewards-tier-header"
//                   style={{ background: unlocked ? tier.color : "#ddd" }}
//                 >
//                   <span>{tier.name}</span>
//                   <span className="userRewards-threshold">{tier.threshold}+</span>
//                 </div>
//                 <p className="userRewards-tier-desc">{tier.desc}</p>
//                 <button
//                   onClick={() => confirmClaim(tier.key)}
//                   disabled={!unlocked || claiming}
//                   style={{
//                     background: unlocked ? tier.color : "#ccc",
//                   }}
//                 >
//                   {claiming ? "Claiming..." : unlocked ? "Claim" : "Locked"}
//                 </button>
//               </div>
//             );
//           })}
//         </div>
//       </div>

//       {/* Coupon */}
//       {summary.latestCoupon && (
//         <div className="userRewards-coupon-card">
//           <h3>Active Coupon</h3>
//           <div className="userRewards-coupon-inner">
//             <div className="userRewards-coupon-info">
//               <div>
//                 <h4>Discount Coupon</h4>
//                 <p>Save on your next purchase</p>
//               </div>
//               <div className="userRewards-expiry">
//                 <span>Expires in</span>
//                 <strong>{expiryDays} days</strong>
//               </div>
//             </div>
//             <div className="userRewards-code-box">
//               <div>
//                 <small>Coupon Code</small>
//                 <h2>{summary.latestCoupon}</h2>
//               </div>
//               <button
//                 onClick={() =>
//                   navigator.clipboard.writeText(summary.latestCoupon)
//                 }
//               >
//                 Copy
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Modal */}
//       {showModal && (
//         <div className="userRewards-modal-overlay">
//           <div className="userRewards-modal">
//             <h3>⚠️ Active Coupon Detected</h3>
//             <p>
//               You already have an active coupon (<b>{summary.latestCoupon}</b>){" "}
//               expiring in {expiryDays} days. Claiming a new one will replace it.
//             </p>
//             <div className="userRewards-modal-buttons">
//               <button onClick={() => setShowModal(false)} className="cancel">
//                 Cancel
//               </button>
//               <button
//                 onClick={() => handleClaimTier(pendingTier)}
//                 className="confirm"
//               >
//                 Claim Anyway
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }












import React, { useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";
import { URL } from "../../../config";
import { FaGift, FaLock, FaCheck, FaCopy, FaMedal, FaStar, FaCrown, FaGem,FaTrophy, FaFire, FaTicketAlt, FaCheckCircle } from "react-icons/fa";
import { FaDiamond } from "react-icons/fa6";
import "./userRewards.css";
import { useTranslation } from "react-i18next";
import Loader from "../../../Components/LoaderSpin/Loader";

const TIERS = [
  { key: "bronze", threshold: 100, color: "#E4A853", icon: FaMedal },
  { key: "silver", threshold: 200, color: "#D4D4D4", icon: FaStar },
  { key: "gold", threshold: 300, color: "#FFE55C", icon: FaCrown },
  { key: "premium", threshold: 500, color: "#A855F7", icon: FaGem },
  { key: "diamond", threshold: 1000, color: "#5DD5D9", icon: FaDiamond },
  { key: "elite", threshold: 1500, color: "#9333EA", icon: FaTrophy },
  { key: "legend", threshold: 2000, color: "#FF5555", icon: FaFire },
];

export default function UserRewards() {
  const { t } = useTranslation();
  const [summary, setSummary] = useState({
    rewardPoints: 0,
    lifetimeRewardPoints: 0,
    latestCoupon: null,
    expiryDate: null,
  });
  const [loading, setLoading] = useState(false);
  const [claimingTier, setClaimingTier] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [successData, setSuccessData] = useState(null);
  const [pendingTier, setPendingTier] = useState(null);
  const [copySuccess, setCopySuccess] = useState(false);
  const [showToast, setShowToast] = useState(false);

  const points = Number(summary.rewardPoints || 0);
  const expiryDays = summary.expiryDate
    ? Math.max(
        0,
        Math.ceil(
          (new Date(summary.expiryDate) - new Date()) / (1000 * 60 * 60 * 24)
        )
      )
    : null;

  // find current & next tier
  const currentTier =
    [...TIERS].reverse().find((tier) => points >= tier.threshold) || TIERS[0];
  const nextTier =
    TIERS.find((tier) => tier.threshold > points) || TIERS[TIERS.length - 1];
  const progressPct = Math.min(
    100,
    Math.round((points / nextTier.threshold) * 100)
  );
  const pointsToNext = Math.max(0, nextTier.threshold - points);

  // useEffect(() => {
  //   const token = localStorage.getItem("token");
  //   if (!token) return;
  //   const decoded = jwtDecode(token);
  //   const rawId = decoded.Id?.startsWith("user-")
  //     ? decoded.Id.split("user-")[1]
  //     : decoded.Id;

  //   fetch(`${URL}/users/${rawId}/summary`)
  //     .then((r) => r.json())
  //     .then((data) => setSummary(data))
  //     .catch(console.error);
  // }, []);

  useEffect(() => {
    const load = async () => {
       const token = localStorage.getItem("token");
       if (!token) return;
       const decoded = jwtDecode(token);
       const rawId = decoded.Id?.startsWith("user-")
         ? decoded.Id.split("user-")[1]
         : decoded.Id;
       setLoading(true);
       try {
         const r = await fetch(`${URL}/users/${rawId}/summary`);
         const data = await r.json();
         setSummary(data);
       } catch (e) {
         console.error(e);
       } finally {
         setLoading(false);
       }
     };
     load();
  }, []);

  const confirmClaim = (tierKey) => {
    if (summary.latestCoupon) {
      setPendingTier(tierKey);
      setShowModal(true);
    } else {
      handleClaimTier(tierKey);
    }
  };

  const handleClaimTier = async (tierKey) => {
    if (claimingTier) return;
    try {
      setClaimingTier(tierKey);
      setShowModal(false);
      setLoading(true);
      const token = localStorage.getItem("token");
      const { Id } = jwtDecode(token);
      const rawId = Id?.startsWith("user-") ? Id.split("user-")[1] : Id;

      const res = await fetch(`${URL}/users/${rawId}/claim`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ tierKey }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data?.message || "Claim failed");

      setSummary((prev) => ({
        ...prev,
        rewardPoints: data.remainingPoints,
        latestCoupon: data.code,
        expiryDate: data.expiryDate,
      }));

      showSuccessMessage({
        tier: data.tier,
        code: data.code,
        discountValue: data.discountValue,
        remainingPoints: data.remainingPoints,
      });

    } catch (e) {
      showErrorMessage(e.message);
    } finally {
      setClaimingTier(null);
      setLoading(false);
    }
  };

  const copyCoupon = async () => {
    try {
      await navigator.clipboard.writeText(summary.latestCoupon);
      setCopySuccess(true);
      setShowToast(true);
      
      setTimeout(() => {
        setCopySuccess(false);
        setShowToast(false);
      }, 2000);
    } catch (err) {
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = summary.latestCoupon;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      
      setCopySuccess(true);
      setShowToast(true);
      setTimeout(() => {
        setCopySuccess(false);
        setShowToast(false);
      }, 2000);
    }
  };

  const showSuccessMessage = (messageData) => {
  setSuccessData(messageData);
  setShowSuccessModal(true);
};
  const showErrorMessage = (message) => {
    // You can replace this with a better notification system
    alert(message);
  };

  return (
    <div className="rewards-wrapper">

      <Loader show={loading} />

      {/* Current Status Banner */}
      <div className="rw-banner shimmer-effect">
        <div className="rw-banner-content">
          <div className="rw-left">
            <div className="rw-icon">
              <FaGift />
            </div>
            <div className="rw-lines">
              <div className="rw-title">{t("rewards.title", "Rewards")}</div>
              {/* <div className="rw-sub">{points} pts — {pointsToNext} pts to next level</div> */}
              <div className="rw-sub">
                {t("rewards.progressText", {
                  points,
                  pointsToNext,
                  defaultValue: "{{points}} pts — {{pointsToNext}} pts to next level",
                })}
              </div>

            </div>
          </div>
          <div className="rw-right">
            <div className="rw-chip">{currentTier.key.toUpperCase()}</div>
          </div>
        </div>
        <div className="rw-progress-container">
          <div className="rw-bar">
            <div className="rw-fill" style={{ width: `${progressPct}%` }} />
          </div>
        </div>
      </div>

      {/* Levels Section */}
      <div className="rw-card">
        <div className="rw-card-title">{t("rewards.levelsTitle", "Levels")}</div>
        <div className="rw-tiers">
          {TIERS.map((tier) => {
            const unlocked = points >= tier.threshold;
            const claiming = claimingTier === tier.key;
            const IconComponent = tier.icon;
            
            return (
              <div
                key={tier.key}
                className={`rw-tier ${unlocked ? "achieved" : "locked"}`}
                style={{
                  borderColor: unlocked ? tier.color : "#e5e7eb",
                  opacity: unlocked ? 1 : 0.7,
                }}
              >
                <div 
                  className="rw-tier-header"
                  style={{
                    background: unlocked 
                      ? `linear-gradient(135deg, ${tier.color}, ${tier.color}dd)` 
                      : "linear-gradient(135deg, #9ca3af, #6b7280)"
                  }}
                >
                  <div className="rw-tier-header-content">
                    <div className="rw-tier-icon">
                      <IconComponent />
                    </div>
                    <span className="rw-tier-name">
                      {t(`rewards.tiers.${tier.key}.name`, tier.key.charAt(0).toUpperCase() + tier.key.slice(1))}
                    </span>
                    <span className="rw-tier-threshold">{tier.threshold}+</span>
                  </div>
                </div>

                <div className="rw-tier-body">
                  <div className="rw-tier-desc">
                    {t(`rewards.tiers.${tier.key}.desc`, `${tier.key.charAt(0).toUpperCase() + tier.key.slice(1)} level benefits and rewards.`)}
                  </div>

                  <button
                    className={`rw-claim-btn ${!unlocked ? "locked" : ""}`}
                    disabled={!unlocked || claiming}
                    onClick={() => confirmClaim(tier.key)}
                    style={{
                      background: unlocked 
                        ? `linear-gradient(135deg, ${tier.color}, ${tier.color}dd)` 
                        : "#ccc",
                    }}
                  >
                    {claiming ? (
                      <>
                        <div className="spinner"></div>
                        Claiming...
                      </>
                    ) : unlocked ? (
                      <>
                        <FaCheck /> Claim
                      </>
                    ) : (
                      <>
                        <FaLock /> Locked
                      </>
                    )}
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Active Coupon Section */}
      {summary.latestCoupon && (
        <div className="rw-coupon-card">
          {/* <div className="rw-coupon-header">
            <h3>{t("rewards.activeCoupon", "Active Coupon")}</h3>
          </div> */}
          
          <div className="rw-coupon-content">
            <div className="rw-coupon-decorations">
              <div className="rw-decoration rw-decoration-1"></div>
              <div className="rw-decoration rw-decoration-2"></div>
            </div>
            
            <div className="rw-coupon-main">
              <div className="rw-coupon-info">
                <div className="rw-coupon-icon">
                  <FaTicketAlt />
                </div>
                <div className="rw-coupon-details">
                  {/* <h4>Discount Coupon</h4>
                  <p>Save on your next order</p> */}

                  <h4>{t("rewards.couponTitle", "Discount Coupon")}</h4>
                  <p>{t("rewards.couponSubtitle", "Save on your next order")}</p>
                </div>
                <div className="rw-coupon-expiry">
                  {/* <p>Expires in</p> */}
                  <p>{t("rewards.expiresIn", "Expires in")}</p>
                  <p className="rw-expiry-days">
                    {/* {expiryDays || 30} days */}
                    {expiryDays || 30} {t("rewards.days", "days")}
                    </p>
                </div>
              </div>
              
              <div className="rw-coupon-code-section">
                <div className="rw-coupon-code-container">
                  <div className="rw-coupon-label">
                    {/* Coupon Code */}
                    {t("rewards.couponCodeLabel", "Coupon Code")}
                    </div>
                  <div className="rw-coupon-code">{summary.latestCoupon}</div>
                </div>
                <button 
                  className={`rw-copy-btn ${copySuccess ? 'copied' : ''}`}
                  onClick={copyCoupon}
                >
                  {copySuccess ? (
                    <>
                      <FaCheckCircle /> {t("rewards.copied", "Copied!")}
                    </>
                  ) : (
                    <>
                      <FaCopy />  {t("rewards.copy", "Copy")}
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}


      {showSuccessModal && successData && (
      <div className="rw-success-modal-overlay">
        <div className="rw-success-modal">
          <div className="rw-success-checkmark">
            <div className="checkmark-circle">
            <div className="background"></div>
            <FaTrophy className="rw-success-trophy" />
          </div>

          </div>
          {/* <h3 className="rw-success-title">🎉 {successData.tier} Tier Claimed!</h3> */}
          <h3 className="rw-success-title">
            {t("rewards.successTitle", {
              tier: successData.tier,
              defaultValue: `🎉 ${successData.tier} Tier Claimed!`,
            })}
          </h3>
          {/* <p className="rw-success-text">
            You've successfully claimed your <strong>{successData.tier}</strong> reward.
          </p> */}

          <p className="rw-success-text">
            {t("rewards.successText", {
              tier: successData.tier,
              defaultValue: `You've successfully claimed your ${successData.tier} reward.`,
            })}
          </p>

          <div className="rw-success-details">
            <div className="rw-success-item">
              {/* <span>Coupon Code:</span> */}
               <span>{t("rewards.successCouponCode", "Coupon Code")}:</span>
              <strong>{successData.code}</strong>
            </div>
            <div className="rw-success-item">
              {/* <span>Discount:</span> */}
              <span>{t("rewards.successDiscount", "Discount")}:</span>
              <strong>{successData.discountValue} Tk</strong>
            </div>
            <div className="rw-success-item">
              {/* <span>Remaining Points:</span> */}
              <span>{t("rewards.successRemainingPoints", "Remaining Points")}:</span>
              <strong>{successData.remainingPoints}</strong>
            </div>
          </div>

          <button className="rw-success-close" onClick={() => setShowSuccessModal(false)}>
            {/* Okay */}
            {t("rewards.successClose", "Oaky")}
          </button>
        </div>
      </div>
    )}


      {/* Modal */}
      {showModal && (
        <div className="rw-modal-overlay">
          <div className="rw-modal">
            <div className="rw-modal-header">
              {/* <h3>⚠️ Active Coupon Detected</h3> */}
              <h3>{t("rewards.modalTitle", "⚠️ Active Coupon Detected")}</h3>
            </div>
            <div className="rw-modal-body">
              {/* <p>
                You already have a coupon (<strong>{summary.latestCoupon}</strong>)
                {expiryDays ? ` expiring in ${expiryDays} days.` : "."}
              </p>
              <p>
                Claiming a new one will <strong>replace</strong> your current coupon.
              </p> */}

              <p>
                {t("rewards.modalBodyHave", "You already have a coupon")} 
                (<strong>{summary.latestCoupon}</strong>)
                {expiryDays ? ` ${t("rewards.modalExpiring", "expiring in")} ${expiryDays} ${t("rewards.days", "days")}.` : "."}
              </p>
              <p>
                {t("rewards.modalReplaceNote", "Claiming a new one will replace your current coupon.")}
              </p>

            </div>
            <div className="rw-modal-actions">
              <button
                className="rw-btn-cancel"
                onClick={() => setShowModal(false)}
              >
                {/* Cancel */}
                {t("rewards.cancel", "Cancel")}
              </button>
              <button
                className="rw-btn-confirm"
                onClick={() => handleClaimTier(pendingTier)}
              >
                {/* Claim Anyway */}
                {t("rewards.claimAnyway", "Claim Anyway")}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Toast Notification */}
      {showToast && (
        <div className="rw-toast">
          <div className="rw-toast-content">
            <FaCheckCircle />
            {/* <span>Coupon code copied to clipboard!</span> */}
            <span>{t("rewards.toastCopied", "Coupon code copied to clipboard!")}</span>
          </div>
        </div>
      )}
    </div>
  );
}